import type { RouteObject } from 'react-router';
import { TaobaoFormPage } from './TaobaoFormPage';
import { TaobaoPage } from './TaobaoPage';
import { TaobaoDetailPage } from './TaobaoDetail';

/** 淘宝店（path 相对 /v2）。页签（订单 / 出库记录 / 退货记录）、筛选、搜索都在 URL 查询参数里 */
export const routes: RouteObject[] = [
  { path: 'taobao/new', element: <TaobaoFormPage mode="create" /> },
  { path: 'taobao/:id/edit', element: <TaobaoFormPage mode="edit" /> },
  { path: 'taobao', element: <TaobaoPage /> },
  { path: 'taobao/:id', element: <TaobaoDetailPage /> },
];
